import {Type} from 'class-transformer';

export class EventPeriod {
  @Type(() => Date)
  startDate: Date;
  @Type(() => Date)
  endDate: Date;

  constructor(startDate?: Date, endDate?: Date) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}
